export default __webpack_public_path__ + "static/media/tool_item_1_m.7cace7b7.png";